import "../styles/components/DifficultyLevels.css"

interface DifficultyLevelsProps {
    difficulty?: string
    difficultyValue?: number
    variant?: number
}

export function DifficultyLevels({
                                     difficulty = '',
                                     difficultyValue = 0,
                                     variant = 0
                                 }: DifficultyLevelsProps) {

    const renderDifficultyDots = (value: number) => {
        const dots = []
        for (let i = 0; i < 5; i++) {
            dots.push(
                <span
                    key={i}
                    className="lvl"
                >{i < value && (<span></span>)}</span>
            )
        }
        return dots
    }

    return (
        <div className={`difficulty-level variant-${variant}`}>
            <div className="difficulty-level-inner">
                <div className="dots">{renderDifficultyDots(difficultyValue)}</div>
                <div className="level-text">
                    <span className="text">{difficulty}</span>
                </div>
            </div>
        </div>
    )
}
